import { RequestOptions } from "http";

export const APP_NAMESPACE = `ufAppShell`;
export const CMS_USERNAME_MODEL = `$UserName`;
export const ORC_PATH = `/msapi/idp-content-orchestration/v1`;
export const ROOT_TOKEN = `%{ROOT}`;
export const SEARCH_API_URL = `https://services.att.com/search/v2/sitesearchapi/suggestions?app-id=sales&customer=consumer&q=`;
export const APPLICATION_NAME = `UF`;
export const PAGE_FUNCTION = `Other`;
export const LINE_OF_BUSINESS = `VIDEO`;
export const OWNERSHIP = `VIDEO`;
export const CONTENT_PAGE_SECTION_ID = `Personalized Page`;
export const CONTENT_SYSTEM = `AEM`;
export const SLOT_FRIENDLY_NAME = `ABTestSplit`;
export const SITE_SECTION = `myatt Sales`;
export const FLOW_CODE = `Prospect`;
export const LEGAL_MODAL_URL = "/modal-legal";
export const TIME_OUT_URL = "/timeout=true";
//export const PROXY_6DOT5 = "http://pxyapp.proxy.att.com:8080";
//export const PROXY_6DOT5 = "http://proxy.conexus.svc.local:3128"; //Changed proxy for DCP

export const TVPROMISE_RESULTS_MODAL_URL = "tvpromise/modal-message-display";

export const headers: RequestOptions | RequestInit = {
  headers: { "Content-Type": "application/json", "User-Agent": "WhirledPeas" },
  timeout: 10000,
};

export const REFERENCE_COMPONENT_PATH = ["sales/www/components/pagespecific", "sales/streamtv/components/pagespecific"]